import { React, useState, useEffect } from "react";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  LinearProgress,
  TablePagination,
} from "@mui/material";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../api_Routes";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { showIconByServiceId } from "../../../helpers/showIconByServiceId";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {useCenteredSnackbar} from "../../../tools/useCenteredSnackbar";



const LastMinutesHistory = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar,closeSnackbar } = useSnackbar();
    const { showCenteredPopup } = useCenteredSnackbar();
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [filtersChanged, setFiltersChanged] = useState(false);
  const [data, setData] = useState([]);
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };


    const action = key => (
        <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => closeSnackbar(key)}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
    );
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };
  const baseApi = api_Routes.dashboard.lastMinuteHistory.view;
  const [history, setHistory] = useState([]);
  const [pageloading, setPageLoading] = useState(true); // State for loading
  const [selectedFilter, setSelectedFilter] = useState("all");
  const calculateDiscount = (discount, discount_type, price) => {
    const numDiscount = Number(discount) || 0;
    const numPrice = Number(price) || 0;
    switch (discount_type) {
      case "const":
        return numDiscount.toFixed(2);
      case "percentage":
        return ((numPrice * numDiscount) / 100).toFixed(2);
      default:
        return "0.00";
    }
  };
  useEffect(() => {
    ad_History();
  }, [selectedFilter]);

  const ad_History = async () => {
    setPageLoading(true); // Show loader
    setPageLoading(true);
    let url = `${baseApi}?per_page=${rowsPerPage}&page=${currentPage + 1}`;

    if (selectedFilter !== "all") {
      url += `&status=${selectedFilter}`;
    }

    const { response } = await Helper.Get({
      url,
      hasToken: true,
    });

    if (response) {
      setData(response);
      setHistory(
        response.data.map((history) => ({
          id: history.id,
          title: history.title,
          description: history.description,
          status: history.status,
            logo: history.logo,
          count_hours_subscriptions: history.count_hours_subscriptions,
            created_at: history.created_at,
        }))
      );
    } else {
    }
    setPageLoading(false); // Hide loader
  };

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
    setCurrentPage(0);
    setFiltersChanged(true);
  };

  const handleDownload = async (report) => {
    try {
      const link = document.createElement("a");
      link.href = report;
      link.setAttribute("download", "image.jpg");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
        showCenteredPopup(error || "Failed to download report",
            { variant: "error",
                persist: true });
      // enqueueSnackbar(error || "Failed to download report", {
      //   variant: "error",
      //     persist: true,
      //     action,
      // });
    }
  };
  useEffect(() => {
    if (filtersChanged) {
      setCurrentPage(0);
      setFiltersChanged(false);
    } else {
      ad_History();
    }
  }, [filtersChanged, currentPage, rowsPerPage ]);
  return (
    <>
      <Box>
        <Typography
          sx={{
            color: "#474747",
            fontSize: "24px",
            lineHeight: "30px",
            fontWeight: "600",
          }}
        >
          Your Last Minutes
        </Typography>
        <Box
          sx={{
          display: { sm: "flex", xs: "grid" },
          justifyContent:'space-between',
            gridTemplateColumns: { sm: "auto", xs: "1fr 1fr" },
            flexDirection: "row",
            gap: "10px",
            marginTop: "20px",
        }}>
          <Box
              sx={{
                display: { sm: "flex", xs: "grid" },
                gridTemplateColumns: { sm: "auto", xs: "1fr 1fr" },
                flexDirection: "row",
                gap: "10px",
                marginTop: "20px",
              }}
          >
            {["all", "pending", "in_progress", "complete"].map((filter) => (
                <Button
                    key={filter}
                    variant={selectedFilter === filter ? "contained" : "outlined"}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#4ea27d",
                        color: "white",
                      },
                      borderRadius: "5px",
                      border: "2px solid #4ea27d",
                      color: selectedFilter === filter ? "white" : "#303030",
                      fontSize: "14px",
                      fontWeight: "600",
                      paddingBlock: "10px",
                      lineHeight: "18px",
                      width: { sm: "130px", xs: "100%" },
                      backgroundColor:
                          selectedFilter === filter ? "#4ea27d" : "white",
                    }}
                    onClick={() => handleFilterChange(filter)}
                >
                  {filter.replace("_", " ")}
                </Button>
            ))}
          </Box>
          <Button
              key={'add'}
              variant={"contained"}
              sx={{
                "&:hover": {
                  backgroundColor: "#4ea27d",
                  color: "white",
                },
                borderRadius: "5px",
                border: "2px solid #4ea27d",
                color: "white",
                fontSize: "14px",
                fontWeight: "600",
                paddingBlock: "2px",
                lineHeight: "15px",
                minWidth: { sm: "130px", xs: "100%" },
                backgroundColor: "#4ea27d",
              }}
              onClick={() => navigate('/post-last-minute')}
          >
            Add Your Last Minut
          </Button>
        </Box>



        {/* Show loader when pageloading is true */}
        {pageloading && (
          <Box sx={{ width: "100%", marginTop: "10px" }}>
            <LinearProgress />
          </Box>
        )}

        <TableContainer
          component={Paper}
          sx={{
            boxShadow: "none",
            border: "2px solid #4ea27d",
            marginTop: "20px",
          }}
        >
          { history?.length > 0 ? (
            <>
              <Table>
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: "#D1DDE4",
                    }}
                  >
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #4ea27d",
                      }}
                    >
                      ID
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #4ea27d",
                      }}
                    >
                      Image
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #4ea27d",
                      }}
                    >
                      Title
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #4ea27d",
                      }}
                    >
                      Description
                    </TableCell>

                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #4ea27d",
                      }}
                    >
                      Status
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #4ea27d",
                      }}
                    >
                      Created Date
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #4ea27d",
                      }}
                    >
                      Hours
                    </TableCell>

                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #4ea27d",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {history.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        backgroundColor: "#E5EDFF",
                        borderBlock: "2px solid #4ea27d",
                      }}
                    >
                      <TableCell
                        sx={{
                          textAlign: "center",
                          color: "#333333",
                          borderInlineEnd: "1px solid #4ea27d",
                        }}
                      >
                        {row.id}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          borderInlineEnd: "1px solid #4ea27d",
                          color: "#333333",
                        }}
                      >
                        <Box
                          className="icons"
                          sx={{
                            height: "40px",
                            display: "flex",
                            gap: "8px",
                            justifyContent: "center",
                            overflow: "hidden",
                            width: "100%",
                            paddingInline: "5px",
                          }}
                        >
                          {row?.logo ? (
                            <img
                              src={row?.logo}
                              alt="icon"
                              key={index}
                              style={{
                                height: "100%",
                                maxWidth: "50px",
                                objectFit: "contain",
                              }}
                            />
                          ) : (
                            "x"
                          )}
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          borderInlineEnd: "1px solid #4ea27d",
                          color: "#333333",
                        }}
                      >
                        {row.title}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          borderInlineEnd: "1px solid #4ea27d",
                          color: "#333333",
                        }}
                      >
                        {row.description}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          borderInlineEnd: "1px solid #4ea27d",
                          color: "#333333",
                        }}
                      >
                        {row.status}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          borderInlineEnd: "1px solid #4ea27d",
                          color: "#333333",
                        }}
                      >
                        {row.created_at}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          borderInlineEnd: "1px solid #4ea27d",
                          color: "#333333",
                        }}
                      >
                        {row.count_hours_subscriptions}
                      </TableCell>

                      <TableCell
                        sx={{
                          textAlign: "center",
                          color: "#333333",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        {/*  <Button*/}
                        {/*      sx={{*/}
                        {/*          background: "#ECA601",*/}
                        {/*          boxShadow: `*/}
                        {/*  0px 3px 3px #00000040, */}
                        {/*  inset 0px 4px 7px #FFFFFF40*/}
                        {/*`,*/}
                        {/*          color: "white",*/}
                        {/*          borderRadius: "6px",*/}
                        {/*          width: "85px",*/}
                        {/*          fontSize: "12px",*/}
                        {/*      }}*/}
                        {/*      onClick={() =>*/}
                        {/*          navigate(*/}
                        {/*              `/dashboard/ad-history/statistic/${row?.id}`*/}
                        {/*          )*/}
                        {/*      }*/}
                        {/*  >*/}
                        {/*      Statistics*/}
                        {/*  </Button>*/}
                        {/*  <Button*/}
                        {/*      sx={{*/}
                        {/*          background: "#4ea27d",*/}
                        {/*          boxShadow: `*/}
                        {/*  0px 3px 3px #00000040, */}
                        {/*  inset 0px 4px 7px #FFFFFF40*/}
                        {/*`,*/}
                        {/*          color: "white",*/}
                        {/*          borderRadius: "6px",*/}
                        {/*          width: "85px",*/}
                        {/*          fontSize: "12px",*/}
                        {/*      }}*/}
                        {/*      onClick={() =>*/}
                        {/*          navigate(*/}
                        {/*              `/dashboard/ad-history/edit/${row?.id}`*/}
                        {/*          )*/}
                        {/*      }*/}
                        {/*  >*/}
                        {/*      Edit*/}
                        {/*  </Button>*/}
                       {/*     <Button*/}
                       {/*       sx={{*/}
                       {/*         backgroundColor: "#ECA601",*/}
                       {/*         boxShadow: `*/}
                       {/*  0px 3px 3px #00000040, */}
                       {/*  inset 0px 4px 7px #FFFFFF40*/}
                       {/*`,*/}
                       {/*         color: "white",*/}
                       {/*         borderRadius: "6px",*/}
                       {/*         width: "85px",*/}
                       {/*         fontSize: "12px",*/}
                       {/*       }}*/}
                       {/*       onClick={() => handleDownload(row?.report)}*/}
                       {/*     >*/}
                       {/*       Report*/}
                       {/*     </Button>*/}


                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <div className="mt-4 flex justify-center items-center">
                <TablePagination
                  page={currentPage}
                  className="mt-auto"
                  onPageChange={handlePageChange}
                  count={data.pagination.total}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  variant="outlined"
                  shape="rounded"
                  rowsPerPageOptions={[ 25, 50,100]}
                />
              </div>
            </>
          )  : (
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#D1DDE4" }}>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#333333",
                      textAlign: "center",
                      border: "1px solid #4ea27d",
                    }}
                  >
                    There are no data yet
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          )}
        </TableContainer>
      </Box>
    </>
  );
};

export default LastMinutesHistory;
